import { NavbarWrapper } from './wrapper';
import { Navbar } from './navbar';
import { NavbarMobileBottom } from './mobile-bottom';
import { DesktopSubMenu } from './desktop-submenu';
import { MobileSubMenu } from './mobile-submenu';
import type { NavbarServerProps } from './type';
import { useMemo } from 'react';

export function NavbarServer({
  top,
  isMobile,
  initialTop,
  transitionToTop,
  isScrolled,
  isMenuOpen,
  onToggleMenuOpen,
  hideBadge,
  claimSections,
  bottom = -100,
  className,
  ctaHref,
  onClickCta,
  phone,
  navLinks,
}: NavbarServerProps) {
  const submenu = claimSections.map(({ name, pages }) => {
    const firstPage = pages?.at(-1) ?? null;

    return {
      label: name,
      url: firstPage ? firstPage.slug : '#',
    };
  });

  const initialState = !isScrolled && !isMenuOpen;

  const onlyNumberPhone = useMemo(() => {
    if (!phone) {
      return '';
    }
    const onlyNumber = phone?.replace(/[^\d]/g, '');
    return `tel:+1${onlyNumber}`;
  }, [phone]);

  return (
    <>
      <NavbarWrapper
        top={top}
        initialTop={initialTop}
        transitionToTop={transitionToTop}
        isMenuOpen={isMenuOpen}
        hideBadge={hideBadge}
        initialState={initialState}
        className={className}
      >
        <Navbar
          initialState={initialState}
          onToggleMenuOpen={onToggleMenuOpen}
          ctaHref={ctaHref}
          onClickCta={onClickCta}
          phone={onlyNumberPhone}
          navLinks={navLinks}
        />
        <DesktopSubMenu submenu={submenu} />
        <MobileSubMenu
          submenu={submenu}
          ctaHref={ctaHref}
          onClickCta={onClickCta}
          navLinks={navLinks}
        />
      </NavbarWrapper>
      {isMobile && (
        <NavbarMobileBottom
          bottom={bottom}
          phone={onlyNumberPhone}
          ctaHref={ctaHref}
          onClickCta={onClickCta}
        />
      )}
    </>
  );
}

export default NavbarServer;
